// extracted by mini-css-extract-plugin
module.exports = {"noSpeechScene":"SubtitlesItemsList-modulenoSpeechScene1an","addBtn":"SubtitlesItemsList-moduleaddBtn1i5","message":"SubtitlesItemsList-modulemessage13T"};